import { gql, permitFields } from 'providers/tanstack-query/utils'

import type { DomainRichPlacementInterstitialConfigurationDTO } from '../types/domainRichPlacementInterstitialConfigurationDTO'
import type { Ability } from 'providers/casl'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

type Props = {
  ability: Ability
}

export const DOMAIN_RICH_PLACEMENT_INTERSTITIAL_CONFIGURATION_FRAGMENT = ({
  ability,
}: Props): TypedDocumentNode<DomainRichPlacementInterstitialConfigurationDTO> => gql`
  fragment DomainRichPlacementInterstitialConfigurationFragment on DomainRichPlacementInterstitialConfiguration {
    ${permitFields<DomainRichPlacementInterstitialConfigurationDTO>({
      availability: ability.can('read', 'DomainRichPlacementsFeature-interstitialEmployeeSettings'),
    })}
    customVariableName
    customVariableTriggerEnabled
    customVariableValue
    enabled
    matchType
    path
    pathTriggerEnabled
  }
`
